import React from "react";
import ContentLoader from "react-content-loader";

const LoaderMesAnnonces = (props) => {
  return (
    <ContentLoader
      viewBox="0 0 700 420"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      backgroundColor="#f5f5f5"
      foregroundColor="#dbdbdb"
      {...props}
    >
      {/* Onglets */}
      <rect x="20" y="18" rx="12" ry="12" width="90" height="34" />
      <rect x="120" y="18" rx="12" ry="12" width="120" height="34" />
      <rect x="250" y="18" rx="12" ry="12" width="140" height="34" />

      {/* Row 1 */}
      <rect x="20" y="78" rx="10" ry="10" width="660" height="78" />
      <rect x="38" y="96" rx="6" ry="6" width="70" height="12" />
      <rect x="38" y="116" rx="6" ry="6" width="52" height="12" />
      <rect x="125" y="92" rx="10" ry="10" width="92" height="62" />
      <rect x="230" y="92" rx="6" ry="6" width="280" height="14" />
      <rect x="230" y="114" rx="6" ry="6" width="160" height="12" />
      <rect x="230" y="134" rx="6" ry="6" width="210" height="12" />
      <rect x="560" y="120" rx="8" ry="8" width="90" height="16" />

      {/* Row 2 */}
      <rect x="20" y="172" rx="10" ry="10" width="660" height="78" />
      <rect x="38" y="190" rx="6" ry="6" width="70" height="12" />
      <rect x="38" y="210" rx="6" ry="6" width="52" height="12" />
      <rect x="125" y="186" rx="10" ry="10" width="92" height="62" />
      <rect x="230" y="186" rx="6" ry="6" width="300" height="14" />
      <rect x="230" y="208" rx="6" ry="6" width="170" height="12" />
      <rect x="230" y="228" rx="6" ry="6" width="230" height="12" />
      <rect x="560" y="214" rx="8" ry="8" width="90" height="16" />

      {/* Row 3 */}
      <rect x="20" y="266" rx="10" ry="10" width="660" height="78" />
      <rect x="38" y="284" rx="6" ry="6" width="70" height="12" />
      <rect x="38" y="304" rx="6" ry="6" width="52" height="12" />
      <rect x="125" y="280" rx="10" ry="10" width="92" height="62" />
      <rect x="230" y="280" rx="6" ry="6" width="260" height="14" />
      <rect x="230" y="302" rx="6" ry="6" width="190" height="12" />
      <rect x="230" y="322" rx="6" ry="6" width="240" height="12" />
      <rect x="560" y="308" rx="8" ry="8" width="90" height="16" />

      {/* Row 4 */}
      <rect x="20" y="360" rx="10" ry="10" width="660" height="78" />
      <rect x="38" y="378" rx="6" ry="6" width="70" height="12" />
      <rect x="38" y="398" rx="6" ry="6" width="52" height="12" />
      <rect x="125" y="374" rx="10" ry="10" width="92" height="62" />
      <rect x="230" y="374" rx="6" ry="6" width="310" height="14" />
      <rect x="230" y="396" rx="6" ry="6" width="160" height="12" />
      <rect x="230" y="416" rx="6" ry="6" width="210" height="12" />
      <rect x="560" y="402" rx="8" ry="8" width="90" height="16" />
    </ContentLoader>
  );
};

export default LoaderMesAnnonces;
